import api from '../../http-common';

// Swiss temp milk samples

const getSwissMilkSamplesData = (id: string, data?: any) =>
  api.post(`/farmers/${id}/temp/milk-payment/milk-samples/individual-values/get-index-data`, data)

const getSwissMilkSamples = (id: string, data?: any) =>
  api.post(`/farmers/${id}/temp/milk-payment/milk-samples/individual-values/index`, data)

// Swiss temp milk deliveries

const getSwissMilkDeliveriesData = (id: string) =>
  api.post(`/farmers/${id}/temp/milk-payment/milk-deliveries/get-index-data`)

const getSwissMilkDeliveries = (id: string, data?: any) =>
  api.post(`/farmers/${id}/temp/milk-payment/milk-deliveries/index`, data)

export const SwissFarmersShowService = {
  getSwissMilkSamplesData,
  getSwissMilkSamples,
  getSwissMilkDeliveriesData,
  getSwissMilkDeliveries
}
